// Generación del código de embed, compartida entre el modal de un asset
// (BunkeyHost) y el de galería (MultiBunkeyHostModal).
// El template sale byte a byte igual al que se venía copiando: hay snippets
// pegados en sitios de clientes y no queremos que dos versiones diverjan.

export const MAX_EMBED_GALLERY_ASSETS = 3;

export const getEmbedSite = () =>
  process.env.REACT_APP_BUNKEY_ENV === "production"
    ? "https://dam.bunkey.tv"
    : process.env.REACT_APP_BUNKEY_ENV === "qa"
    ? "http://dam-qa.bunkey.tv"
    : "http://dam-dev.bunkey.tv";

/**
 * @param path  lo que va después de /embed/ — "<id>/<quality>" para un asset,
 *              "gallery/<id>,<id>/<quality>" para una galería.
 * @param title texto del atributo title del iframe.
 */
export const buildEmbedSnippet = (path, title) => {
  const site = getEmbedSite();

  return `<iframe
      width="100%"
      height="100%"
      src="${site}/embed/${path}"
      title="${title}"
      frameborder="0"
      scrolling="no"
      allowfullscreen
    ></iframe>`;
};

export const buildAssetEmbedPath = (id, quality) => `${id}/${quality}`;

export const buildGalleryEmbedPath = (ids, quality) =>
  `gallery/${ids.join(",")}/${quality}`;
